import { Routes, Route } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { AuthenticationServiceProvider } from "../services/authentication.service";
import MasterLayout from "./master.layout";
import { PrivateRoute } from "../components";
import roles from "../utils/constants/roles";

const Login = lazy(() => import("../pages/login"));
const NotFoundPage = lazy(() => import("../pages/error/not.found"));
const HomePage = lazy(() => import("../pages/home"));
const CentreDetailsPage = lazy(() => import("../pages/centre-details"));
const MaintenancePage = lazy(() => import("../pages/maintenance"));

const CENTRE_ROUTE_ROLES = [
  roles.ROLE_CENTRE_READONLY,
  roles.ROLE_CENTRE_READWRITE,
  roles.ROLE_CENTRE_SUPERADMIN,
  roles.ROLE_PROPERTY_READONLY,
  roles.ROLE_PROPERTY_READWRITE,
  roles.ROLE_PROPERTY_SUPERADMIN,
];

const PROPERTY_ROUTE_ROLES = [
  roles.ROLE_PROPERTY_READONLY,
  roles.ROLE_PROPERTY_READWRITE,
  roles.ROLE_PROPERTY_SUPERADMIN,
];

function RemoveBootstrapShell() {
  useEffect(() => {
    const shell = document.getElementById("app-bootstrap-shell");
    if (shell) shell.remove();
  }, []);
  return null;
}

export default function ProviderLayout() {
  return (
    <AuthenticationServiceProvider>
      <RemoveBootstrapShell />
      <ToastContainer />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <MasterLayout />
              </PrivateRoute>
            }
          >
            <Route
              index
              element={
                <PrivateRoute roles={roles.ALL_ROLES}>
                  <HomePage />
                </PrivateRoute>
              }
            />
            {/* Both routes render CentreDetailsPage — it reads the URL param
                (centreId or propertyId) via useParams and switches mode accordingly. */}
            <Route
              path="centre/:centreId"
              element={
                <PrivateRoute roles={CENTRE_ROUTE_ROLES}>
                  <CentreDetailsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="property/:propertyId"
              element={
                <PrivateRoute roles={PROPERTY_ROUTE_ROLES}>
                  <CentreDetailsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="maintenance"
              element={
                <PrivateRoute roles={roles.ALL_ROLES}>
                  <MaintenancePage />
                </PrivateRoute>
              }
            />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </AuthenticationServiceProvider>
  );
}
